import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import PlacementSelector from "./PlacementSelector";
import { getGoogleAspectRatios } from "selectors/Social2";
import { changePlacement } from "reducers/Social";

import "./GooglePreview.css";

export default function GooglePreview(props) {
	const dispatch = useDispatch();
	const aspectRatios = useSelector(getGoogleAspectRatios);

	useEffect(() => {
		let [initialAspectRatio] = aspectRatios;

		if(!initialAspectRatio){ return; }
		dispatch(changePlacement(initialAspectRatio));
	}, []);

	return (
		<>
			{ aspectRatios.length > 1 && (
				<div className="google-placement-selector" >
					<PlacementSelector label="Aspect Ratio" previewOpts={aspectRatios} />
				</div>
			)}
			{ props.children }
		</>
	);
}

GooglePreview.displayName = "GooglePreview";
